import React, {useMemo} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import debounce from "lodash/debounce";

import {formatHSCode} from 'utils/helpers';
import TextField from "@mui/material/TextField";
import { Search as SearchIcon } from '@vedmarket/ui-kit';

import {COLORS} from "../../../../../../../../../../../../../../../config/constants";

enum CODE_FORM {
    CODE = 'code',
}

const HelpTabsSearchField = ({onSearch, label, code, noValidationOnBlur}: HelpSearchFieldProps) => {

  const { t } = useTranslation()

  const { register, setError, clearErrors, formState: { errors } } = useForm<HelpSearchForm>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      [CODE_FORM.CODE]: formatHSCode(code || '')
    }
  })

  const debouncedRequest = useMemo(
    () => debounce((val: string | undefined) => onSearch(val), 500),
    [ onSearch ]
  );

  return <TextField
    {...register(CODE_FORM.CODE)}
    error={Boolean(errors[CODE_FORM.CODE])}
    helperText={errors[CODE_FORM.CODE]?.message}
    variant='outlined'
    label={label}
    InputLabelProps={{ shrink: true }}
    fullWidth
    sx={{
      '.MuiOutlinedInput-root:not(.MuiInputBase-multiline)': {
        height: '40px',
        minHeight: '40px',
        paddingRight: '12px',
      },
      '.MuiOutlinedInput-input': {
        padding: '8px 12px',
      },
      '.MuiInputAdornment-root p': {
        fontSize: '14px',
      },
      '.MuiOutlinedInput-notchedOutline legend': {
        fontSize: '12px',
      },
      '.MuiInputBase-root': {
        fontSize: '14px',
      },
    }}
    InputProps={{
      endAdornment: <SearchIcon color={COLORS.LIGHT_ACTION} />,
    }}
    onChange={({ target: { value: query } }) => {
      if (query.length >= 3) {
        clearErrors(CODE_FORM.CODE);
        debouncedRequest(query)
      }
      if (!query.length) {
        debouncedRequest(undefined);
      }
    }}
    onBlur={({ target: { value } }) => {

      const codeWithoutSpaces = value.replace(/\s+/g, "");

      if (codeWithoutSpaces.length !== 10 && !noValidationOnBlur) {
        setError(CODE_FORM.CODE, { type: "custom", message: t('errors__message__incorrectHsCode') })
      } else {
        clearErrors(CODE_FORM.CODE);
      }
    }}
  />

}

export default HelpTabsSearchField

